/** Stock quantities: "12,5" / "12.5" → 12.5 (3 decimals); empty / invalid → null. */
export function parseQty(raw) {
  if (raw === '' || raw === null || raw === undefined) return null;
  const n = Number(String(raw).replace(',', '.').trim());
  return Number.isFinite(n) ? Math.round(n * 1000) / 1000 : null;
}
